import { useQuery } from '@tanstack/react-query';
import type { UseQueryReturnType } from '../@types';
import { gqlClient } from '../clients';
import { graphql } from '../gql';
import { queryClient } from '../query-client';
import { coreApiKeys } from './keys';

export type ReturnTypeFromUseCoreAcademicNamespace = UseQueryReturnType<
  typeof useCoreAcademicNamespace
>[number];

const coreAcademicNamespaces = graphql(/* GraphQL */ `
  query core_academicNamespaces {
    core_academicNamespaces {
      academicNamespaceId
      type
      name
      year
      description
      isActiveDefaultNamespace
      startDate
      endDate
    }
  }
`);

const coreAcademicNamespaceQuery = {
  queryKey: coreApiKeys.academicNamespaces.all(),
  queryFn: async () => {
    const { core_academicNamespaces } = await gqlClient.request(
      coreAcademicNamespaces,
    );
    return {
      core_academicNamespaces: core_academicNamespaces?.sort(
        (yearA, yearB) => yearB.year - yearA.year,
      ),
    };
  },
};

export function getCoreAcademicNamespace() {
  return queryClient.fetchQuery(coreAcademicNamespaceQuery);
}

export function useCoreAcademicNamespace() {
  return useQuery({
    ...coreAcademicNamespaceQuery,
    select: ({ core_academicNamespaces }) => core_academicNamespaces,
  });
}
